import React, { useEffect } from 'react'

export default function OrderActionBox({ order, isForceCancel, onOk, onForceCancel, unlockOrder }) {
  useEffect(() => {
    return () => {}
  }, [order])
  function action() {
    return (
      <>
        <div>
          <button className="btn btn-dark mr-2" onClick={() => unlockOrder(order)}>
            ยกเลิก
          </button>
          <button className="btn btn-primary" onClick={(e) => onOk(e)}>
            ยืนยัน
          </button>
        </div>
      </>
    )
  }
  function render() {
    switch (order.status) {
      case 'CONFIRMED':
        return action()
      case 'SUCCESS':
        if (order.isDelivery) return null
        return isForceCancel ? (
          action()
        ) : (
          <button className="btn btn-danger" onClick={(e) => onForceCancel(e)}>
            {' '}
            ยกเลิกคำสั่งซื้อ{' '}
          </button>
        )
      case 'CANCEL':
        return <></>
      default:
        return action()
    }
  }
  return <>{render()}</>
}
